<template>
  <form-component
    class="status-form"
    :class="{ 'status-form--hasImage': hasImage }"
    @submit.prevent="handleFormSubmit"
  >
    <textarea-component
      id="body"
      ref="statusContentInput"
      v-model="statusContent"
      class="status-form__input textarea--unstyled"
    />
    <uploaded-image-preview
      v-if="hasImage"
      :images="images"
    />
    <div class="status-form__actions">
      <image-upload-button
        @click="handleImageUploadClick"
      />
    </div>
    <loading-button
      class="status-form__submit-button button"
      type="submit"
      :loading="tryingToUpdateStatus"
      button-type="status"
    >
      Post status
    </loading-button>
  </form-component>
</template>

<script>
import imageUploadMixin from '@/mixins/image-upload-mixin';
import LoadingButton from '@/components/Global/LoadingButton.vue';
import ImageUploadButton from '@/components/ImageUpload/ImageUploadButton.vue';
import UploadedImagePreview from '@/components/ImageUpload/UploadedImagePreview.vue';
import TextareaComponent from '@/components/Inputs/TextareaComponent.vue';
import { UPDATE_USER_STATUS } from '@/graphql/mutations/status-mutation';
import { mapGetters } from 'vuex';

export default {
  name: 'StatusForm',
  components: {
    LoadingButton,
    ImageUploadButton,
    UploadedImagePreview,
    TextareaComponent,
  },
  mixins: [imageUploadMixin],
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      statusContent: '',
      tryingToUpdateStatus: false,
    };
  },
  computed: {
    ...mapGetters([
      'isAdmin',
    ]),
  },
  mounted() {
    this.statusContent = this.value;
    this.$nextTick(() => {
      this.$refs.statusContentInput.focus();
    });
  },
  methods: {
    handleFormSubmit() {
      this.tryingToUpdateStatus = true;

      if (!this.statusContent) {
        this.$store.dispatch('addToastNotification', {
          toastType: 'error',
          description: 'Oops! It doesn\'t look like you added a status.',
          type: 'Status Update',
        });
        this.tryingToUpdateStatus = false;
        return;
      }

      this.$apollo.mutate({
        mutation: UPDATE_USER_STATUS,
        variables: {
          body: this.transformContent(),
        },
      }).then((response) => {
        if (this.hasImage && !this.isAdmin) {
          this.$store.dispatch('addToastNotification', {
            toastType: 'success',
            description: 'This status requires an extra set of eyes. We’ll review and get back to you.',
            type: 'Status Update',
          });
          this.$emit('statusPending');
        } else {
          this.$store.dispatch('addToastNotification', {
            toastType: 'success',
            description: 'You updated your status.',
            type: 'Status Update',
          });
          this.$emit('newStatus', response.data.updateProfileStatus);
        }
      }).catch(() => {
        this.$store.dispatch('addGenericErrorNotification');
      }).finally(() => {
        this.tryingToUpdateStatus = false;
      });
    },
    transformContent() {
      return this.appendImages(this.statusContent);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_status-form';
</style>

<docs>
</docs>
